module.exports = __webpack_public_path__ + "static/assets/e5451eaac705d1385e4b0dbabe938e3d.png";